import script from "./manager.vue?vue&type=script&setup=true&lang=js"
export * from "./manager.vue?vue&type=script&setup=true&lang=js"

import "./manager.vue?vue&type=style&index=0&id=1e373f55&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\shiv_mfg_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1e373f55"]])

export default __exports__